import React from 'react';
import Title from 'components/TitleWithIcon';
import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
import {useStyles} from './style';
import StepperSolicitudEmpadronamiento from './Stepper'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AlertDialogSlide(props) {
    const classes = useStyles();
    // console.log('props.: ', props)
    return (
        <div>
            <Dialog     open={props.open}
                        // maxWidth={"md"}
                        // fullWidth={true}
                        fullScreen 
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={props.handleClose}
                        aria-labelledby="alert-dialog-slide-title"
                        aria-describedby="alert-dialog-slide-description"
            >
                <Title title={"SOLICITUD DE RENAP NO. "+props.idSolicitudObtenido+" / NUEVA "+(props.accionDeProceso ? props.accionDeProceso : '')+' '+ (props.isNacional ? props.isNacional :'')} icon={"/menu/Document.png"}/>
                <StepperSolicitudEmpadronamiento {...props} cerrarDialogo={props.handleClose} actualizarTabla={props.actualizarTabla} nroBoleta={props.nroBoleta}
                    fotosVieneVacio={props.fotosVieneVacio} mensajeFotosVieneVacio={props.mensajeFotosVieneVacio} usuarioEstaEmpadronado={props.usuarioEstaEmpadronado}
                    open={props.open} ObtenerTotalDeSolicitudesPendientesDeRealizar={props.ObtenerTotalDeSolicitudesPendientesDeRealizar}
                    datosResidenciaExtranjeroRenapSeleccionado={props.datosResidenciaExtranjeroRenapSeleccionado}
                />
            </Dialog>
        </div>
    );
}